<template>
  <div class="chapter-page">
    <skill-header title="章节选择" @back="confirmSelection" />
    <main class="chapter-list">
      <directory-node
        v-for="(node, index) in directories"
        :key="node.categoryId || node.id || index"
        :node="node"
        selectable
        :selected-ids="selectedIds"
        @select="toggleNode"
      />
    </main>
  </div>
</template>

<script>
import { getTree, getSkillCenterFullTree } from '@/api/subject/index.js'
import { Toast } from 'vant'
import DirectoryNode from './DirectoryNode.vue'
import SkillHeader from './SkillHeader.vue'
import {
  nodeId,
  parseQueryArray,
  skillCenterQuestionCategories,
  skillCenterTreeData
} from './shared'

export default {
  name: 'SkillCenterQuestionChapter',
  components: { DirectoryNode, SkillHeader },
  data() {
    return {
      directories: [],
      selectedIds: []
    }
  },
  async created() {
    this.selectedIds = parseQueryArray(this.$route.query.selectedCategoryIds)
    if (String(this.$route.query.preview) === '1') {
      this.directories = [
        { id: '1', label: '影像诊断', questionCount: 4, children: [{ id: '11', label: '影像诊断基础', questionCount: 4, children: [] }] },
        {
          id: '2', label: '心电图', questionCount: 8, expanded: true, children: [
            { id: '21', label: '第一章 绪论', doneNum: 50, questionCount: 82, children: [] },
            { id: '22', label: '第二章 细胞的基本功能', doneNum: 18, questionCount: 122, children: [] },
            { id: '23', label: '第三章 血液', doneNum: 30, questionCount: 68, children: [] }
          ]
        },
        { id: '3', label: '医德医风', questionCount: 5, children: [{ id: '31', label: '医德医风基础', questionCount: 5, children: [] }] },
        { id: '4', label: '病例分析', questionCount: 8, children: [{ id: '41', label: '病例分析基础', questionCount: 8, children: [] }] }
      ]
      this.selectedIds = ['22']
      return
    }
    try {
      if (this.$route.query.skillCenter) {
        const res = await getSkillCenterFullTree()
        const data = skillCenterTreeData(res)
        this.directories = skillCenterQuestionCategories(
          data,
          this.$route.query.majorType || '',
          this.$route.query.categoryOrganId,
          this.$route.query.organCategoryId
        )
      } else {
        const res = await getTree('', { majorType: this.$route.query.majorType || '' })
        const data = res && Array.isArray(res.data) ? res.data : []
        this.directories = data.length === 1 && data[0].children ? data[0].children : data
      }
    } catch (error) {
      this.directories = []
      Toast(error && error.msg ? error.msg : '章节加载失败')
    }
  },
  methods: {
    toggleNode(node) {
      const id = nodeId(node)
      if (!id) return
      if (this.selectedIds.includes(id)) {
        this.selectedIds = this.selectedIds.filter((item) => item !== id)
      } else {
        this.selectedIds.push(id)
      }
    },
    confirmSelection() {
      this.$router.replace({
        path: '/skillCenter/group',
        query: {
          ...this.$route.query,
          selectedCategoryIds: JSON.stringify(this.selectedIds),
          skillCenter: 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chapter-page {
  min-height: 100vh;
  background: #ffffff url("~@/assets/images/skillCenterQuestion/directory-background.png") top center / 375px 282px no-repeat;
  color: #111111;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  box-sizing: border-box;
}

.chapter-list {
  padding: 20px 19px;
}

@media (min-width: 600px) {
  .chapter-page {
    width: 375px;
    margin: 0 auto;
  }
}
</style>
